import { render } from "./BargainPrice.vue?vue&type=template&id=5e37b7a8&scoped=true"
import script from "./BargainPrice.vue?vue&type=script&lang=js"
export * from "./BargainPrice.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=5e37b7a8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e37b7a8"]])

export default __exports__